import axios from "axios";

export const axiosCall = async (url, type, data = '', headers = '', params = '') => {
    return new Promise(async (resolve) => {
        if(url === '') {
            resolve(false);
        }
        if(!['get', 'post'].includes(type.toLowerCase())) {
            resolve(false);
        }
        let resp;
        let respError;
        if(type.toLowerCase() === 'get') {
            await axios.get(url, {params: (params !== '' ? params: {}), headers: (headers !== '' ? headers: {})})
            .then((res) => {
                resp = res;
            })
            .catch((err) => {
                respError = err;
            });
        } else if(type.toLowerCase() === 'post') {
            const formData = data;
            await axios?.post(url, formData, {params: (params !== '' ? params: {}), headers: (headers !== '' ? headers : {})})
            .then((res) => {
                resp = res;
            })
            .catch((err) => {
                respError = err;
            });
        } else {
            console.log('Unidentified axios request');
        }
        if(resp && (resp?.status === 200 || resp?.status === 201)) {
            resolve(resp);
        } else {
            if (respError?.response?.status === 403) {
                localStorage.removeItem('token');
                window.location.href = '/finance/app/auth/login'; // Call the custom hook function
            }
            resolve(respError?.response || false);
        }
    });
};
